const tablePrice = {
  country: {
    zh: 'Country',
    en: 'Country',
    pu: 'País'
  },
  state: {
    zh: 'State',
    en: 'State',
    pu: 'Estado'
  },
  regions: {
    zh: 'Regions',
    en: 'Regions',
    pu: 'Regiões'
  },
  city: {
    zh: 'City',
    en: 'City',
    pu: 'Cidade'
  },
  ibgeCodes: {
    zh: 'IBGE Codes',
    en: 'IBGE Codes',
    pu: 'Código IBGE'
  },
  capitalDistance: {
    zh: 'Capital distance',
    en: 'Capital distance',
    pu: 'Distância da capital'
  },
  baseDistance: {
    zh: 'Base distance',
    en: 'Base distance',
    pu: 'Distância da base'
  },
  macroRegions: {
    zh: 'Macro regions',
    en: 'Macro regions',
    pu: 'Macro regiões'
  },
  microRegions: {
    zh: 'Micro regions',
    en: 'Micro regions',
    pu: 'Micro regiões'
  },
  deliveryPricesZoning: {
    zh: 'Delivery prices zoning',
    en: 'Delivery prices zoning',
    pu: 'Preço de entrega'
  },
  minimumShipping: {
    zh: 'Minimum shipping',
    en: 'Minimum shipping',
    pu: 'Frete mínimo'
  },
  minZipCode: {
    zh: 'Min zip code',
    en: 'Min zip code',
    pu: 'CEP mínimo'
  },
  maxZipCode: {
    zh: 'Max zip code',
    en: 'Max zip code',
    pu: 'CEP máximo'
  },
  indexZipCode: {
    zh: 'Index zip code',
    en: 'Index zip code',
    pu: 'CEP índice'
  },
  localCluster: {
    zh: 'Local cluster',
    en: 'Local cluster',
    pu: 'Cluster local'
  },
  iata: {
    zh: 'IATA',
    en: 'IATA',
    pu: 'IATA'
  },
  titularPartner: {
    zh: 'Titular partner',
    en: 'Titular partner',
    pu: 'Sócio titular'
  },
  baseAddress: {
    zh: 'Base address',
    en: 'Base address',
    pu: 'Endereço base'
  },
  segment: {
    zh: 'Segment',
    en: 'Segment',
    pu: 'Segmento'
  },
  modal: {
    zh: 'Modal',
    en: 'Modal',
    pu: 'Modal'
  },
  riskArea: {
    zh: 'Risk area',
    en: 'Risk area',
    pu: 'Área de risco'
  },
  lastMileTerm: {
    zh: 'Last mile term',
    en: 'Last mile term',
    pu: 'Prazo last mile'
  },
  addKg: {
    zh: 'Add KG',
    en: 'Add KG',
    pu: 'Adiocionar KG'
  },
  createdAt: {
    zh: 'Created at',
    en: 'Created at',
    pu: 'Criado em'
  },
  add: {
    zh: 'Add worksheet',
    en: 'Add worksheet',
    pu: 'Adicionar'
  },
  tablePrice: {
    zh: 'Table price',
    en: 'Table price',
    pu: 'Tabela de preços'
  },
  success: {
    zh: 'Successfully performed operation',
    en: 'Successfully performed operation',
    pu: 'Operação realizada com sucesso'
  },
  filters: {
    zh: 'Filters',
    en: 'Filters',
    pu: 'Filtros'
  },
  placeholderMacroRegion: {
    zh: 'Enter the macro region',
    en: 'Enter the macro region',
    pu: 'Digite a macro região'
  },
  placeholderMicroRegion: {
    zh: 'Enter the micro region',
    en: 'Enter the micro region',
    pu: 'Digite a micro região'
  },
  placeholderCountry: {
    zh: 'Enter the country',
    en: 'Enter the country',
    pu: 'Digite o país'
  },
  placeholderCity: {
    zh: 'Enter the city',
    en: 'Enter the city',
    pu: 'Digite a cidade'
  },
  placeholderState: {
    zh: 'Enter the state',
    en: 'Enter the state',
    pu: 'Digite o estado'
  },
  placeholderMaxZipCode: {
    zh: 'Enter the max zip code',
    en: 'Enter the max zip code',
    pu: 'Digite o CEP máximo'
  },
  placeholderMinZipCode: {
    zh: 'Enter the min zip code',
    en: 'Enter the min zip code',
    pu: 'Digite o CEP mínimo'
  },
  consult: {
    zh: 'Consult',
    en: 'Consult',
    pu: 'Pesquisar'
  },
  clean: {
    zh: 'Clean',
    en: 'Clean',
    pu: 'Limpar'
  },
  networkDimension: {
    zh: '网点维度',
    en: 'Branch Dimension',
    pu: 'Dimensão da Agência'
  },
  regionDimension: {
    zh: '大区维度',
    en: 'Region Dimension',
    pu: 'Dimensão Regional'
  },
  customerDimension: {
    zh: '客户维度',
    en: 'Customer Dimension',
    pu: 'Dimensão do Cliente'
  },
  // 4179 tab 标签葡语优化（原 networkDimension 等 key 被其它报表共用，这里建本报表专用）
  siteDimensionTab: {
    zh: '网点维度',
    en: 'By IATA',
    pu: 'Por IATA'
  },
  regionDimensionTab: {
    zh: '大区维度',
    en: 'By Region',
    pu: 'Por região'
  },
  customerDimensionTab: {
    zh: '客户维度',
    en: 'By Customer',
    pu: 'Por cliente'
  },
  // 4179 网点列/合计列葡语（GlobalSetObj.Outlets、GlobalSetObj.sum 为全局共享 key 不动，本报表用专用）
  networkSite: {
    zh: '网点',
    en: 'IATA',
    pu: 'IATA'
  },
  totalText: {
    zh: '合计',
    en: 'Total',
    pu: 'Total'
  },
  // 4179 网点/大区纬度 客户/商户筛选
  merchantName: {
    zh: '商户名称',
    en: 'Merchant Name',
    pu: 'Nome do Comerciante'
  },
  // 4216 骑手维度（葡语文案按需求表）
  riderDimensionTab: {
    zh: '骑手维度',
    en: 'By Rider',
    pu: 'Por Entregador'
  },
  rider: {
    zh: '骑手',
    en: 'Rider',
    pu: 'Entregador'
  },
  riderSite: {
    zh: '所属网点',
    en: 'Unit',
    pu: 'Unidade'
  },
  riderState: {
    zh: '所属州',
    en: 'State',
    pu: 'Estado'
  },
  riderRegion: {
    zh: '所属大区',
    en: 'Region',
    pu: 'Região'
  },
  riderClosedLoopTime: {
    zh: '闭环时间',
    en: 'Closed-loop Time',
    pu: 'Data de Fechamento'
  },
  avgDailySigned: {
    zh: '日均签收量',
    en: 'Daily Avg. Deliveries',
    pu: 'Média Diária'
  },
  workOrderCount: {
    zh: '工单量',
    en: 'Tickets',
    pu: 'Qtd. Tickets'
  },
  riderWorkOrderCreateRate: {
    zh: '工单创建率',
    en: 'Opening Rate',
    pu: 'Taxa de Abertura'
  },
  confirmRate: {
    zh: '认定率',
    en: 'Confirmation Rate',
    pu: 'Taxa de Confirmação'
  },
  riderFalseSignRate: {
    zh: '虚假签收率',
    en: 'Fake Delivery Rate',
    pu: 'Taxa de Entrega Falsa'
  },
  // 4179 客户纬度三个量列
  deliveryQuantity: {
    zh: '签收量',
    en: 'Delivery Quantity',
    pu: 'Qtd. de entregas'
  },
  falseDeliveryQuantity: {
    zh: '虚假签收量',
    en: 'Fake Delivery Quantity',
    pu: 'Qtd. de fake delivery'
  },
  workOrderCreateCount: {
    zh: '工单创建量',
    en: 'Ticket Creation Count',
    pu: 'Qtd. de acareação'
  },
  customerName: {
    zh: '客户名称',
    en: 'Customer Name',
    pu: 'Nome do Cliente'
  },
  workOrderCreateRate: {
    zh: '工单创建率',
    en: 'Ticket Creation Rate',
    pu: 'Taxa de criação de acareação'
  },
  falseSignEstablishedRate: {
    zh: '虚假签收成立率',
    en: 'False Sign Established Rate',
    pu: 'Taxa de Assinatura Falsa Confirmada'
  },
  uploadCustomerConfig: {
    zh: '上传客户配置',
    en: 'Upload Customer Config',
    pu: 'Carregar Config de Cliente'
  },
  unmatchedCustomerTip: {
    zh: '以下客户名未匹配到系统客户：',
    en: 'These customer names did not match system customers: ',
    pu: 'Estes nomes de clientes não correspondem aos clientes do sistema: '
  },
  region: {
    zh: '大区',
    en: 'Region',
    pu: 'Região'
  },
  monthToDate: {
    zh: '当月累计',
    en: 'Month-to-Date',
    pu: 'Acumulado do Mês'
  },
  dailyAverage: {
    zh: '日均',
    en: 'Daily Average',
    pu: 'Média Diária'
  },
  falseDeliveryCount: {
    zh: '虚假签收数',
    en: 'False Delivery Count',
    pu: 'Qtd. de fake delivery'
  },
  deliveryCount: {
    zh: '签收数',
    en: 'Delivery Count',
    pu: 'Qtd. de entregas'
  },
  falseDeliveryRate: {
    zh: '虚假签收率',
    en: 'False Delivery Rate',
    pu: 'Taxa de fake delivery'
  },
  dayOverDay: {
    zh: '日环比',
    en: 'Day-over-Day',
    pu: 'Variação Diária'
  },
  weekOverWeek: {
    zh: '周环比',
    en: 'Week-over-Week',
    pu: 'Variação Semanal'
  },
  monthOverMonth: {
    zh: '月环比',
    en: 'Month-over-Month',
    pu: 'Variação Mensal'
  },
  dayOverDay1: {
    zh: '环比前日',
    en: 'Day-over-Day',
    pu: 'Variação Diária'
  },
  weekOverWeek1: {
    zh: '环比上周同期',
    en: 'Week-over-Week (Same Period)',
    pu: 'Variação Semanal (Mesmo Período)'
  },
  invalidResponse: {
    zh: '无效回复',
    en: 'Invalid Response',
    pu: 'Resposta inválida'
  },
  confirmedLost: {
    zh: '确认丢失',
    en: 'Confirmed Lost',
    pu: 'Perda confirmada'
  },
  complaintType: {
    zh: '投诉来源',
    en: 'Complaint Type',
    pu: 'Origem da reclamação'
  },
  consumerComplaint: {
    zh: '消费者投诉',
    en: 'Consumer Complaint',
    pu: 'Reclamação do consumidor'
  },
  platformComplaint: {
    zh: '平台投诉',
    en: 'Platform Complaint',
    pu: 'Reclamação da plataforma'
  },
  suspectedLost: {
    zh: '疑似丢失',
    en: 'Suspected Lost',
    pu: 'Suspeita de perda'
  },
  workOrderType: {
    zh: '投诉类型',
    en: 'Work Order Type',
    pu: 'Tipo de Reclamação'
  },
  exportDiscrepancyDetails: {
    zh: '导出差异明细',
    en: 'Export Discrepancy Details',
    pu: 'Exportar Detalhes de Discrepância'
  },
  socialMediaEscalatedComplaint: {
    zh: '社媒升级投诉',
    en: 'Social Media Escalated Complaint',
    pu: 'Reclamação em redes sociais'
  },
  modifyResponsibleHub: {
    zh: '修改责任网点',
    en: 'Modify Responsible Hub',
    pu: 'Modificar Centro Responsável'
  },
  modifyResponsibleStage: {
    zh: '修改责任环节',
    en: 'Modify Responsible Stage',
    pu: 'Modificar Etapa Responsável'
  },
  timeRangeLimit: {
    zh: '时间范围不能超过31天',
    en: 'Time range cannot exceed 31 days',
    pu: 'O intervalo de tempo não pode exceder 31 dias'
  },
  SelectProcessingHub: {
    zh: '选择处理网点',
    en: 'Select Processing Hub',
    pu: 'Selecionar o ponto responsável'
  },
  ActualDeliveryHub: {
    zh: '实际签收网点',
    en: 'Actual Delivery Hub',
    pu: 'Ponto de entrega'
  },
  exportCompartmentData: {
    zh: '导出格口数据',
    en: 'Export Compartment Data',
    pu: 'Exportar Dados do Compartimento'
  },
  externalPushConfirmation: {
    zh: '是否对外推送？',
    en: 'Push externally?',
    pu: 'É para enviar para o cliente?'
  },
  complaintReason: {
    zh: '投诉原因',
    en: 'Complaint Reason',
    pu: 'Motivo da Reclamação'
  },
  nfeKey: {
    zh: 'NFe密钥',
    en: 'NFe Key',
    pu: 'Chave NFe'
  },
  pushParty: {
    zh: '推送方',
    en: 'Push Party',
    pu: 'Parte Remetente'
  },
  pushPartyUrl: {
    zh: '推送方url',
    en: 'Push Party URL',
    pu: 'URL da Parte Remetente'
  },
  receiverParty: {
    zh: '接收方',
    en: 'Receiver Party',
    pu: 'Parte Receptora'
  },
  receiverPartyUrl: {
    zh: '接收方url',
    en: 'Receiver Party URL',
    pu: 'URL da Parte Receptora'
  },
  pushMessage: {
    zh: '推送报文',
    en: 'Push Message',
    pu: 'Mensagem Enviada'
  },
  orderSuccess: {
    zh: '是否下单成功',
    en: 'Order Successful',
    pu: 'Pedido Bem-sucedido'
  },
  anJunOrderMessage: {
    zh: '安骏下单报文',
    en: 'AnJun Order Message',
    pu: 'Mensagem de Pedido AnJun'
  },
  anJunOrderResponseMessage: {
    zh: '安骏下单响应报文',
    en: 'AnJun Order Response Message',
    pu: 'Mensagem de Resposta do Pedido AnJun'
  },
  realtimeTotal: {
    zh: '实时总数',
    en: 'Realtime Total',
    pu: 'Total em Tempo Real'
  },
  pendingPickupTotal: {
    zh: '待揽收运单/包裹总数',
    en: 'Pending Pickup Waybill/Package Total',
    pu: 'Total de Romaneios/Pacotes Pendentes de Coleta'
  },
  todayNewPendingPickup: {
    zh: '今日新增 待揽收运单/包裹',
    en: "Today's New Pending Pickup Waybills/Packages",
    pu: 'Novos Romaneios/Pacotes Pendentes de Coleta Hoje'
  },
  over7Days: {
    zh: '超过7天',
    en: 'Over 7 Days',
    pu: 'Mais de 7 Dias'
  },
  notPickedUpCount: {
    zh: '未揽收运单/包裹数',
    en: 'Not Picked Up Waybill/Package Count',
    pu: 'Contagem de Romaneios/Pacotes Não Coletados'
  },
  within7DaysTo3DaysAgo: {
    zh: '7天内-3天前',
    en: 'Within 7 Days - 3 Days Ago',
    pu: 'Dentro de 7 Dias - 3 Dias Atrás'
  },
  within3DaysTo1DayAgo: {
    zh: '3天内-1天前',
    en: 'Within 3 Days - 1 Day Ago',
    pu: 'Dentro de 3 Dias - 1 Dia Atrás'
  },
  currentDay: {
    zh: '当天',
    en: 'Current Day',
    pu: 'Dia Atual'
  },
  pendingPickupByRegion: {
    zh: '各大区待揽收运单/包裹',
    en: 'Pending Pickup Waybills/Packages by Region',
    pu: 'Romaneios/Pacotes Pendentes de Coleta por Região'
  },
  pendingPickupWaybillPackage: {
    zh: '待揽收运单/包裹',
    en: 'Pending Pickup Waybill/Package',
    pu: 'Romaneio/Pacote Pendente de Coleta'
  },
  orderCustomerCount: {
    zh: '下单客户数',
    en: 'Order Customer Count',
    pu: 'Contagem de Clientes com Pedido'
  },
  midwestRegion: {
    zh: '中西大区',
    en: 'Midwest Region',
    pu: 'Região Centro-Oeste'
  },
  northwestRegion: {
    zh: '西北大区',
    en: 'Northwest Region',
    pu: 'Região Noroeste'
  },
  northeastRegion: {
    zh: '东北大区',
    en: 'Northeast Region',
    pu: 'Região Nordeste'
  },
  northRegion: {
    zh: '北部大区',
    en: 'North Region',
    pu: 'Região Norte'
  },
  southRegion: {
    zh: '南部大区',
    en: 'South Region',
    pu: 'Região Sul'
  },
  southeastRegion: {
    zh: '东南大区',
    en: 'Southeast Region',
    pu: 'Região Sudeste'
  },
  saopauloRegion: {
    zh: '圣保罗大区',
    en: 'São Paulo Region',
    pu: 'Regional São Paulo'
  },
  selectTimeRange: {
    zh: '请选择时间范围',
    en: 'Please select a time range',
    pu: 'Por favor, selecione um intervalo de tempo'
  },
  customerPendingPackageStatistics: {
    zh: '客户待揽收包裹统计',
    en: 'Customer Pending Package Statistics',
    pu: 'Estatísticas de Pacotes Pendentes de Coleta do Cliente'
  },
  noData: { zh: '暂无数据', en: '', ptBr: 'Sem Dados' }
};
export { tablePrice };
